<template>
  <div>
    <PeopleYouMightKnow />
    <div class="mt-4"></div>
    <Articles :loading="articleLoading" :items="featuredArticles"/>
    <div class="mt-4"></div>
    <Challenges :loading="challengeLoading" :items="featuredChallenges"/>
    <div class="mt-4"></div>
    <Ads :loading="adLoading" :items="featuredAds"/>
    <div class="mt-4"></div>
    <FeaturedUsers v-if="featuredUser.length != 0" :loading="userLoading" :items="featuredUser"/>
    <div class="mt-4"></div>
    <News :loading="newsLoading" :items="featuredNews"/>
    <div class="mt-4"></div>
    <info-box/>
    <!-- <div class="mt-4"></div>
    <BlogPosts />
    <div class="mt-4"></div>
    <IndustryNews /> -->
  </div>
</template>

<script>
import Articles from "./Articles.vue";
import FeaturedUsers from "./FeaturedUsers.vue";
import News from "./News.vue";
import BlogPosts from "./BlogPosts.vue";
import IndustryNews from "./IndustryNews.vue";
import PeopleYouMightKnow from "./PeopleYouMightKnow.vue";
import Challenges from "./Challenges.vue";
import Ads from "./Ads.vue";
import InfoBox from './InfoBox.vue';
export default {
  name: "RightSection",
  components: {
    Articles,
    FeaturedUsers,
    News,
    BlogPosts,
    IndustryNews,
    PeopleYouMightKnow,
    Challenges,
    Ads,
    InfoBox,
  },
  mounted() {
    this.getFeaturedArticles();
    this.getFeaturedChallenges();
    this.getFeaturedAds();
    this.getFeaturedNews();
    this.getFeaturedUsers();
  },
};
</script>

<style>
</style>